import classNames from "classnames";
import { useMemo } from "react";

const TotalAmountDetails = ({
  subtotal = 0,
  gst = 0,
  discount = 0,
  coupon = 0,
  showDiscount,
  showCoupon,
}: {
  subtotal?: number;
  gst?: number;
  discount?: number;
  coupon?: number;
  showDiscount?: boolean;
  showCoupon?: boolean;
}) => {
  const total = useMemo(
    () => subtotal + gst - (discount + coupon),
    [subtotal, gst, discount, coupon]
  );

  return (
    <div className="flex flex-col bg-white-ghost p-[20px] rounded-[10px] gap-4">
      <div className="flex text-16px font-semibold">Total Amount</div>
      <InfoRow
        label="Subtotal"
        value={`₹ ${subtotal.toFixed(2)}`}
        valueClassName="border-b-2"
      />
      <InfoRow
        label="Gst & tax"
        value={`₹ ${gst.toFixed(2)}`}
        valueClassName="border-b-2"
      />
      {showDiscount && (
        <InfoRow
          label="Discount"
          value={`₹ ${discount.toFixed(2)}`}
          valueClassName="border-b-2"
        />
      )}
      {showCoupon && (
        <InfoRow
          label="Coupon"
          value={`₹ ${coupon.toFixed(2)}`}
          valueClassName="border-b-2"
        />
      )}
      <InfoRow
        label="Total"
        value={`₹ ${total.toFixed(2) ?? 0}`}
        wrapperClassName="!font-bold"
      />
    </div>
  );
};

export default TotalAmountDetails;

const InfoRow = ({
  label,
  value,
  wrapperClassName,
  valueClassName,
}: {
  label: string;
  value: string;
  wrapperClassName?: string;
  valueClassName?: string;
}) => {
  return (
    <div
      className={classNames(
        "flex items-center gap-3 justify-between text-14px font-semibold leading-6",
        wrapperClassName
      )}
    >
      <div className="w-[80%]">{label}</div>
      <span className={classNames("w-[20%] text-right", valueClassName)}>
        {value}
      </span>
    </div>
  );
};
